// extracted by mini-css-extract-plugin
export default {"id":"_3Yg0vmdzZQ","confirm-input":"_2q9p8MbFcI","confirmInput":"_2q9p8MbFcI","hard-delete-checkbox":"_14TuDRkADD","hardDeleteCheckbox":"_14TuDRkADD"};
    if(module.hot) {
      // 1633091654828
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  